import { DiscountTypeEnum } from 'src/app/enum/discount-type.enum';
import {
  BaseCreateUpdateTunnel,
  BaseInstallationDto,
  BaseTunnelFundingDto,
  BaseTunnelInstallationPrice,
  PricedItem,
} from '../common-tunnel-dtos';
import { Configuration2D } from '../../configuration2d';
import { BathroomFinishingDto, BathroomRangeDto } from '../../common-bathroom-dtos';
import { CompositionConfigurationDto } from '../../mobile/bathroom/bathroom-composition-dtos';

export type BathroomConfiguration = Configuration2D & {
  bathroomConfigurationId: string;
  isLocked: boolean;
};

export type BathroomConfigurationProductDto = {
  id?: string;
  bathroomConfigurationId?: string;
  ean: string;
  qty: number;
  label: string;
  salePrice?: number;
  range?: string;
  installationCode?: string;
  imageSrc?: string;
  isFromConfiguration?: boolean;
};

export type BathroomThumbnailDto = {
  id?: string;
  data: string;
};

export type BaseBathroomConfigurationDto = {
  id: string;
  bathroomConfigurationId: string;
  title?: string;
  products?: BathroomConfigurationProductDto[];
  thumbnail?: BathroomThumbnailDto;
  compositionId?: string;
  compositionName?: string;
  compositionThumbnailUrl?: string;
  compositionConfiguration?: CompositionConfigurationDto;
  isLocked?: boolean;
};

export type BathroomCreateUpdateTunnel = BaseCreateUpdateTunnel & {
  products: BathroomConfigurationProductDto[];
  thumbnail?: BathroomThumbnailDto;
  compositionId?: string;
  compositionConfiguration?: CompositionConfigurationDto;
};

export type BathroomTunnelPricingDto = {
  financing?: BathroomTunnelFinancingDto;
  financingWithInstallation?: BathroomTunnelFinancingDto;
  discountEnum: DiscountTypeEnum;
  installationPrices?: BathroomTunnelInstallationPrice;
  conceptionPrices?: BathroomTunnelConceptionPrice;
  deliveryPrice?: PricedItem;
  totalWithFinancing?: number;
  totalWithoutFinancing?: PricedItem;
  downPayment?: number;
  houseMoreThan2YearsOld: boolean;
  withInstallation: boolean;
};

export type BathroomTunnelFinancingDto = BaseTunnelFundingDto;
export type BathroomTunnelInstallationPrice = BaseTunnelInstallationPrice;

export type BathroomTunnelConceptionPrice = {
  delta?: number;
  withInstallation?: BathroomTunnelConceptionDetailPrice;
  withoutInstallation?: BathroomTunnelConceptionDetailPrice;
  categoryTotals?: Record<string, PricedItem>;
};

export type BathroomTunnelConceptionDetailPrice = {
  productsPrice?: PricedItem;
  totalPrice?: PricedItem;
};

export type BathroomInstallationDto = BaseInstallationDto & {
  installationPrice?: BathroomTunnelInstallationPrice;
  conceptionPrices?: BathroomTunnelConceptionPrice;
};

export type BathroomProductDto = {
  id: string;
  /** Gamme */
  bathroomRangeId?: string;
  bathroomRange?: BathroomRangeDto;
  /** EAN du produit */
  ean?: string;
  /** Libellé du produit */
  label?: string;
  /** Attribut */
  attribute?: ProductAttribute;
  /** Dimensions du produit */
  dimensions?: string;
  /** Matière */
  material?: string;
  /** finition */
  bathroomFinishingId?: string;
  bathroomFinition?: BathroomFinishingDto;
  /** Type d'installation */
  installationType?: InstallationType;
  /** Statut */
  status?: string;
  /** Largeur */
  width?: number;
  /** Hauteur/Épaisseur */
  heightThickness?: number;
  /** Profondeur */
  depth?: number;
  /** Livré monté ou non */
  isAssembled: boolean;
  /** Prix unitaire TTC (prix de vente) */
  salePrice?: number;
  /** Images pour la liste d'achat et le rendu de la configuration */
  thumbnailUrl?: string;
  renderImageUrl?: string;
  doubleProduct?: BathroomProductDto;
};

export enum ProductAttribute {
  None = 0,
  WashbasinTop = 1,
  UnderWashbasin = 2,
  Niche = 3,
  ToiletTop = 4,
  Column = 5,
  Handles = 6,
  CountertopBasin = 7,
}

export enum InstallationType {
  None = 0,
  WallMountedIntegratedHandle = 1,
  WallMountedFixedHandle = 2,
  PushPull = 3,
}
